//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CategoriasAPI from '@/api/promotores/cursos/categorias.api'

export default {
	props: {
		categoria: {
			type: Object,
			default() {
				return {
					nombre: null,
          portada: null,
				}
			}
		}
	},

	data() {
		return {
      categoria_: {...this.categoria},
      portada: null,
			loading: false,
		}
	},

  methods: {
    show() {
      this.$refs.dialog.show();
    },

    hide() {
      this.$refs.dialog.hide();
    },

    inputPortada(file) {
      this.categoria_.portada = URL.createObjectURL(file)
    },

		async submit() {
			try {
				this.loading = true

        let payload = {
          nombre: this.categoria_.nombre
        }

        if (this.categoria_.id) {
          payload.id = this.categoria_.id
        }

        if (this.portada) {
          payload.portada = this.portada
        }

				const categoria = await CategoriasAPI.save(payload)

				this.$emit('ok', categoria)
				this.hide()
			} finally {
				this.loading = false
			}
		},
  },
};
